import React, { useState } from "react";
import MainLayouts from "../../Layout/MainLayouts";
import { Link } from "react-router-dom";
import Spinner from "../spinner/Spinner";
import { useBankAccounts } from "../../hooks/useInventory";
import { ReactComponent as PencilSquare } from "bootstrap-icons/icons/pencil-square.svg";

const BankAccountList = () => {
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");

  const { data, isLoading } = useBankAccounts({ search, status, per_page: 50 });
  const accounts = data?.data?.accounts || [];

  return (
    <MainLayouts>
      <div className="p-6">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold">Company Bank Accounts</h1>
          <Link
            to="/head-office/inventory/bank-accounts/create"
            className="bg-orange1 text-white px-4 py-2 rounded hover:bg-orange-600 transition"
          >
            + Add Account
          </Link>
        </div>

        <div className="bg-white rounded-lg shadow p-4 mb-4 flex flex-wrap gap-3">
          <input
            type="text"
            placeholder="Search accounts..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-orange1 flex-1 min-w-[200px]"
          />
          <select
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            className="border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-orange1"
          >
            <option value="">All Status</option>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>

        {isLoading ? (
          <Spinner loading />
        ) : (
          <div className="bg-white rounded-lg shadow overflow-hidden">
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    {["Bank Name", "Account Name", "Account Number", "Status", "Action"].map((h) => (
                      <th key={h} className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {accounts.length === 0 ? (
                    <tr>
                      <td colSpan={5} className="px-6 py-8 text-center text-gray-500">
                        No bank accounts found.{" "}
                        <Link to="/head-office/inventory/bank-accounts/create" className="text-orange1 underline">
                          Add one
                        </Link>
                      </td>
                    </tr>
                  ) : (
                    accounts.map((acc) => (
                      <tr key={acc.id} className="hover:bg-gray-50">
                        <td className="px-6 py-4 text-sm font-medium text-gray-900">{acc.bank_name}</td>
                        <td className="px-6 py-4 text-sm text-gray-600">{acc.account_name}</td>
                        <td className="px-6 py-4 text-sm text-gray-600">{acc.account_number || "-"}</td>
                        <td className="px-6 py-4">
                          <span style={{
                            padding: "2px 10px", borderRadius: "9999px", fontSize: "0.75rem", fontWeight: 600,
                            backgroundColor: acc.status === "active" ? "#dcfce7" : "#fee2e2",
                            color: acc.status === "active" ? "#166534" : "#991b1b",
                          }}>
                            {acc.status}
                          </span>
                        </td>
                        <td className="px-6 py-4 text-sm font-medium">
                          <div className="flex items-center gap-3">
                            <Link to={`/head-office/inventory/bank-accounts/edit?id=${acc.id}`} className="text-blue-600 hover:text-blue-800" title="Edit">
                              <PencilSquare width={18} height={18} />
                            </Link>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </MainLayouts>
  );
};

export default BankAccountList;
